import { useMemo } from "react"
import useFeatureFlag from "services/featureFlags"
import usePermissions from "services/permissions"
import {
  getAvailableColumns, type ColumnConfig, type ColumnId,
} from "./columnsConfig"

// Columns that require canViewGuestDetails permission (hidden from Door Staff users).
// Mirrors the restriction in AttributeList where PhoneField/EmailField are filtered out.
const RESTRICTED_COLUMNS: ColumnId[] = ["email", "phone"]

const useAvailableColumns = () => {
  const { guestTimestamps: timestampsEnabled, whatsappMessaging } = useFeatureFlag()
  const { canViewGuestDetails } = usePermissions()

  return useMemo(() => {
    const columns = getAvailableColumns({ guestTimestamps: timestampsEnabled, whatsappMessaging })

    if (canViewGuestDetails) return columns

    // Door Staff: strip out email/phone columns entirely
    return Object.entries(columns).reduce((acc, [columnId, config]) => {
      if (RESTRICTED_COLUMNS.includes(columnId as ColumnId)) return acc
      acc[columnId as ColumnId] = config

      return acc
    }, {} as Record<ColumnId, ColumnConfig>)
  }, [timestampsEnabled, whatsappMessaging, canViewGuestDetails])
}

export default useAvailableColumns
